/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  DiscrepancyListFiltersResponseResponse,
  ForbiddenResponse,
  GetDiscrepancyListFiltersParams,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get discrepancy List filters
 * @summary Get All filters for discrepancy list
 */
export const getDiscrepancyListFilters = (
  params?: GetDiscrepancyListFiltersParams,
  signal?: AbortSignal,
) => {
  return customInstance<DiscrepancyListFiltersResponseResponse>({
    url: `/bm-declaration-service/v1/discrepancy/filters`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetDiscrepancyListFiltersQueryKey = (params?: GetDiscrepancyListFiltersParams) => {
  return [`/bm-declaration-service/v1/discrepancy/filters`, ...(params ? [params] : [])] as const;
};

export const getGetDiscrepancyListFiltersQueryOptions = <
  TData = Awaited<ReturnType<typeof getDiscrepancyListFilters>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetDiscrepancyListFiltersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDiscrepancyListFilters>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetDiscrepancyListFiltersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDiscrepancyListFilters>>> = ({
    signal,
  }) => getDiscrepancyListFilters(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDiscrepancyListFilters>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDiscrepancyListFiltersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDiscrepancyListFilters>>
>;
export type GetDiscrepancyListFiltersQueryError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Get All filters for discrepancy list
 */
export const useGetDiscrepancyListFilters = <
  TData = Awaited<ReturnType<typeof getDiscrepancyListFilters>>,
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
>(
  params?: GetDiscrepancyListFiltersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getDiscrepancyListFilters>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetDiscrepancyListFiltersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
